export const environment = {
  production: false,
  APP_ID: '0cf2a791-f4e3-4d38-9597-f36c7ea0ab47',
  API_BASE_URL: 'https://promo-ecs.useast1.dev.arv.aws.ual.com/offers/api/chaseyearofyes',
  IMAGE_BASE_URL: 'https://promo-ecs.useast1.dev.arv.aws.ual.com/chaseyearofyes/assets/',
  ASSETS_BASE_URL: 'https://promo-ecs.useast1.dev.arv.aws.ual.com/assets/img/',

};
